import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {PaletteColorsEnum} from '../../../../../../libs/shared/ui/src/styles/paletteModel';

/*
 * Props.
 */

interface CellTagColorProps {
  name: string;
  color: PaletteColorsEnum;
}

/*
 * Style.
 */

interface TagStyleProps {
  $color: PaletteColorsEnum;
}
const StyledTagDiv = styled.div<TagStyleProps>`
  margin-left: 5px;

  padding: 1px 3px;
  border-radius: 2px;
  background-color: ${(p) => p.theme.palette[p.$color].shade10};
  border: 1px solid ${(p) => p.theme.palette[p.$color].shade30};

  color: ${(p) => p.theme.palette[p.$color].shade40};
  overflow: hidden;
`;

const StyledNameDiv = styled.div`
  line-height: 12px;
  font-size: ${fontSizes.veryTiny};
  font-weight: ${fontWeights.semibold};
  text-transform: uppercase;
  letter-spacing: 0.17px;

  ${ellipsis()};
`;

/*
 * Component.
 */

export const CellTagColor: FC<CellTagColorProps> = (props) => (
  <StyledTagDiv $color={props.color}>
    <StyledNameDiv>{props.name}</StyledNameDiv>
  </StyledTagDiv>
);
